var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm._options),function(option){return _c('li',{key:option.id},[_c('input',{attrs:{"type":"radio","id":option.id,"name":_vm.questionId},domProps:{"value":option.value,"checked":option.selected},on:{"change":function($event){return _vm.select(option)}}}),_c('label',{attrs:{"for":option.id}},[_vm._v(_vm._s(option.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }